import { render } from "./SpinnerComponent.vue?vue&type=template&id=47b43c68"
import script from "./SpinnerComponent.vue?vue&type=script&lang=js"
export * from "./SpinnerComponent.vue?vue&type=script&lang=js"

import "./SpinnerComponent.vue?vue&type=style&index=0&id=47b43c68&lang=css"

import exportComponent from "/Users/mac/MyDev/3-READY/v2t/vid2text/youtest.ru/youtest-front-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__